import styled from 'styled-components';
import Logo from '~/components/Logo';
import Divider from '~/components/Divider';
import { media } from '~/styles/mixins';

export const Container = styled.div`
	max-width: 1318px;
	width: 100%;
	display: flex;
	align-items: center;
	align-self: stretch;
	flex-direction: column;
	justify-content: center;
	margin: 0 auto;
	padding: 0 20px;

	${media.large`
		padding: 0;
	`}
`;

export const Header = styled.div`
	display: none;

	${media.large`
		display: flex;
		width: 100%;
		padding: 0 120px;
		align-items: flex-end;
		gap: 80px;
		justify-content: center;
	`}
`;

export const StreamYardLogoWrapper = styled.div`
	display: flex;
	height: 60px;
	justify-content: center;
	align-items: center;
	flex: 1 0 0;

	${media.medium`
		height: 70px;
	`}

	${media.large`
		height: 80px;
	`}
`;

export const StyledStreamYardLogo = styled(Logo)`
	height: 30px;

	${media.medium`
		height: 35px;
	`}

	${media.large`
		height: 40px;
	`}
`;

export const CompetitorLogoText = styled.span`
	font-size: 20px;
	font-weight: 700;
	line-height: 28px;
	letter-spacing: 0;
	color: ${({ theme }) =>
		theme.tokens
			.COLOR_TOKENS_FILL_INVERTIBLE_NEUTRAL_TRANSPARENT_NEUTRAL_ULTRA_STRONG};

	${media.small`
		font-size: 24px;
		line-height: 32px;
	`}

	${media.medium`
		font-size: 28px;
		line-height: 36px;
	`}

	${media.large`
		font-size: 32px;
		line-height: 40px;
	`}
`;

export const CompetitorLogoWrapper = styled.div`
	display: flex;
	height: 60px;
	justify-content: center;
	align-items: center;
	gap: 8px;
	flex: 1 0 0;

	${media.medium`
		height: 70px;
		gap: 10px;
	`}

	${media.large`
		height: 80px;
		gap: 12px;
	`}
`;

export const Row = styled.div`
	display: flex;
	width: 100%;
	padding: 20px;
	justify-content: center;
	align-items: stretch;
	gap: 20px;
	flex-direction: column;

	${media.medium`
		padding: 20px 40px;
		gap: 30px;
	`}

	${media.large`
		padding: 0 120px;
		gap: 40px;
		flex-direction: row;
		align-items: stretch;
	`}
`;

export const MobileStreamYardLogoWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	padding: 6px;
	border-radius: 100px;
	background: #e2ecff;
`;

export const MobileStyledLogo = styled(Logo)`
	width: 23px;
	height: auto;
`;

export const StyledDivider = styled(Divider).attrs({
	padding: 'none',
	orientation: 'horizontal',
})`
	flex-shrink: 0;
	align-self: stretch;

	${media.large`
		&& {
			width: 1px !important;
			height: auto !important;
			min-height: 100%;
			margin: 0 20px;
			align-self: stretch;
		}
	`}
`;
